import React from "react";
import Banner from "./Banner/Banner";
import {
  partnersData,
  cardData,
  ConferenceData,
  DOIPapersData,
} from "./PublicationsData";
import AuthorGuidelinesImg1 from "../../assets/images/AuthorGuidlinesIcon1.svg";
import AuthorGuidelinesImg2 from "../../assets/images/AuthorGuidlinesIcon2.svg";
import AuthorGuidelinesImg3 from "../../assets/images/AuthorGuidlinesIcon3.svg";

import styles from "./Publications.module.css";

const Publications = () => {
  return (
    <main className={styles.publicationsPage}>
      <Banner />
      <section className={styles.imparcPartners}>
        <div className={styles.container}>
        <h3>
          IMPARC Journals <span>& Partners</span>
        </h3>
        <h5>
          Premier academic journals fostering cutting-edge research and
          scholarly excellence
        </h5>
        <div className={styles.cards}>
          {partnersData.map((item) => (
            <div key={item.id} className={styles.card}>
              <div className={`${item.imageClass} ${styles.image}`}>
                <img src={item.img} alt={item.alt} />
              </div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
              <div className={styles.tagOuter}>
                {item.tags.map((tag, idx) => (
                  <span key={idx} className={styles.tag}>
                    {tag}
                  </span>
                ))}
              </div>
              <p className={styles.time}>{item.time}</p>
              <p className={styles.arrow}>{item.review}</p>
              <button className={styles.btn}>{item.buttonText}</button>
            </div>
          ))}
        </div>
        </div>
      </section>
      <section className={styles.ispnBooks}>
        <div className={styles.container}>
          <h3>
            ISBN Books &{" "}
            <span className={styles.highlight}>Edited Volumes</span>
          </h3>
          <h5>
            Comprehensive scholarly books and edited collections advancing
            research frontiers
          </h5>

          <div className={styles.cards}>
            {cardData.map((card) => (
              <div key={card.id} className={styles.card}>
                <figure>
                  <img src={card.img} alt={card.title} />
                </figure>
                <div className={styles.right}>
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                  <div className={styles.actions}>
                    <span className={styles.tag}>{card.tag}</span>
                    <span className={styles.pages}>{card.pages}</span>
                    <button className={styles.viewBtn}>View Details</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={styles.imparcPartners}>
         <div className={styles.container}>
        <h3>
          Conference <span>Proceedings</span>
        </h3>
        <h5>
          Complete proceedings from IMPARC conferences and collaborative events
        </h5>
        <div className={styles.cards}>
          {ConferenceData.map((item) => (
            <div key={item.id} className={styles.card}>
              <div className={`${item.imageClass} ${styles.image}`}>
                <img src={item.img} alt={item.alt} />
              </div>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
              <div className={styles.tagOuter}>
                {item.tags.map((tag, idx) => (
                  <span key={idx} className={styles.tag}>
                    {tag}
                  </span>
                ))}
                <span className={styles.calendar}>&nbsp;</span>
              </div>
              <p className={styles.papers}>{item.papers}</p>
              <p className={styles.represented}>{item.represented}</p>
              <p className={styles.download}>{item.download}</p>
              <button className={styles.btn}>{item.buttonText}</button>
            </div>
          ))}
        </div>
        </div>
      </section>
      <section className={`${styles.imparcPartners} ${styles.topBorder}`}>
        <div className={styles.container}>
          <h3>
            DOI Papers <span>Showcase</span>
          </h3>
          <h5>
            Featured research papers with Digital Object Identifiers from our
            community
          </h5>
          <div className={styles.cards}>
            {DOIPapersData.map((item) => (
              <div key={item.id} className={`${styles.card} ${styles.expand} `}>
                <div className={styles.leftBlock}>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                  <div className={styles.tagOuter}>
                    {item.tags.map((tag, idx) => (
                      <span key={idx} className={styles.tag}>
                        {tag}
                      </span>
                    ))}
                    <span className={styles.calendar}>&nbsp;</span>
                  </div>
                  <div className={styles.doctorOuter}>
                    <p className={styles.doctorName}>{item.doctorName}</p>
                    <p className={styles.views}>{item.views}</p>
                  </div>
                </div>
                <div className={styles.rightBlock}>
                  <div className={styles.doiblock}>
                    DOI
                    <span>{item.DOI}</span>
                  </div>
                  <p className={styles.time}>{item.time}</p>
                  <button className={styles.btn}>{item.buttonText}</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        className={`${styles.imparcPartners} ${styles.authorGuidelines}`}
      >
        <div className={styles.container}>
          <h3>
            Author <span className={styles.highlight}>Guidelines</span>
          </h3>
          <h5>
            Comprehensive guidelines for authors submitting to IMPARC
            publications
          </h5>

          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={`${styles.image} ${styles.image1} `}>
                <img src={AuthorGuidelinesImg1} alt={"Submission Process"} />
              </div>
              <h4>Submission Process</h4>
              <ol className={styles.numberList}>
                <li>
                  <h6>Manuscript Preparation</h6>
                  <p>Follow IMPARC formatting guidelines & templates</p>
                </li>
                <li>
                  <h6>Online Submission</h6>
                  <p>Submit through our editorial management system</p>
                </li>
                <li>
                  <h6>Peer Review</h6>
                  <p>Undergo rigorous double-blind peer review</p>
                </li>
              </ol>
              <button className={styles.btn}>Download Templates</button>
            </div>
            <div className={styles.card}>
              <div className={`${styles.image} ${styles.image1} `}>
                <img src={AuthorGuidelinesImg2} alt={"Formatting Standards"} />
              </div>
              <h4>Formatting Standards</h4>
              <div className={styles.bgBlock}>
                <h6>Document Structure</h6>
                <ul>
                  <li>Abstract (250 words max)</li>
                  <li>Keywords (5-7 terms)</li>
                  <li>Introduction & Literature Review</li>
                  <li>Methodology & Results</li>
                  <li>Conclusions & References</li>
                </ul>
              </div>
              <div className={styles.bgBlock}>
                <h6>Technical Requirements</h6>
                <ul>
                  <li>Font: Times New Roman, 12pt</li>
                  <li>Spacing: Double-spaced</li>
                  <li>Margins: 1 inch all sides</li>
                  <li>Citation: APA Style</li>
                </ul>
              </div>
              <button className={styles.btn}>Style Guide PDF</button>
            </div>
            <div className={styles.card}>
              <div className={`${styles.image} ${styles.image1} `}>
                <img src={AuthorGuidelinesImg3} alt={"Submission Process"} />
              </div>
              <h4>Ethics & Standards</h4>
              <div className={styles.bgBlock}>
                <h6>Research Ethics</h6>
                <ul>
                  <li> IRB approval for human subjects</li>
                  <li>Animal welfare compliance</li>
                  <li>Data privacy protection</li>
                </ul>
              </div>
              <div className={styles.bgBlock}>
                <h6>Publication Ethics</h6>
                <ul>
                  <li>Plagiarism and self-plagiarism</li>
                  <li>Authorship and conflict of interest</li>
                  <li>Data integrity and transparency</li>
                </ul>
              </div>
              <button className={styles.btn}>Code of Conduct</button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Publications;
